var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyburgoLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 55,
    viewBox: "0 0 197 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8895 25.4012C30.9278 22.1317 28.2578 23.494 27.168 24.5838C28.2578 22.6766 30.9278 18.5353 32.8895 17.2276C34.8511 15.9198 38.8834 20.7066 40.2457 22.8862C44.169 30.7329 42.6978 41.7483 41.8804 46.6525L33.7068 46.5896C36.9763 39.2334 35.3416 29.488 32.8895 25.4012Z",
    fill: "url(#paint0_linear_79_527)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.446 31.1233C16.2149 35.0466 11.9101 31.8778 10.8203 29.4257C12.455 31.0605 15.0706 32.2676 18.9939 23.767C22.9172 15.2665 23.8981 12.324 27.9849 11.5066C35.3411 10.6893 38.3381 18.8001 40.2452 22.8869C32.0716 17.9827 30.4369 20.4976 27.1675 24.5844C24.5519 27.8538 23.6256 29.4885 21.446 31.1233Z",
    fill: "url(#paint1_linear_79_527)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4644 22.8877C-3.33526 27.775 1.55054 40.9377 4.00262 45.5694H9.72411C8.08939 44.752 5.91647 35.1481 6.73381 31.0613C7.72899 26.0853 10.0032 26.9745 12.9935 28.4049C14.8589 29.2972 15.9973 26.9745 16.5422 26.1572C12.4554 28.6093 10.0032 18.1878 3.4644 22.8877Z",
    fill: "url(#paint2_linear_79_527)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4644 22.8877C-3.33526 27.775 1.55054 40.9377 4.00262 45.5694H9.72411C8.08939 44.752 5.91647 35.1481 6.73381 31.0613C7.72899 26.0853 10.0032 26.9745 12.9935 28.4049C14.8589 29.2972 15.9973 26.9745 16.5422 26.1572C12.4554 28.6093 10.0032 18.1878 3.4644 22.8877Z",
    fill: "#7D00B8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4644 22.8877C-3.33526 27.775 1.55054 40.9377 4.00262 45.5694H9.72411C8.08939 44.752 5.91647 35.1481 6.73381 31.0613C7.72899 26.0853 10.0032 26.9745 12.9935 28.4049C14.8589 29.2972 15.9973 26.9745 16.5422 26.1572C12.4554 28.6093 10.0032 18.1878 3.4644 22.8877Z",
    fill: "url(#paint3_linear_79_527)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4644 22.8877C-3.33526 27.775 1.55054 40.9377 4.00262 45.5694H9.72411C8.08939 44.752 5.91647 35.1481 6.73381 31.0613C7.72899 26.0853 10.0032 26.9745 12.9935 28.4049C14.8589 29.2972 15.9973 26.9745 16.5422 26.1572C12.4554 28.6093 10.0032 18.1878 3.4644 22.8877Z",
    fill: "url(#paint4_linear_79_527)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9842,
    cy: 4.90416,
    r: 4.90416,
    fill: "url(#paint5_linear_79_527)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.7333,
    cy: 16.3476,
    r: 3.26944,
    fill: "url(#paint6_linear_79_527)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.7333,
    cy: 16.3476,
    r: 3.26944,
    fill: "url(#paint7_linear_79_527)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.7333,
    cy: 16.3476,
    r: 3.26944,
    fill: "url(#paint8_linear_79_527)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9842,
    cy: 4.90416,
    r: 4.90416,
    fill: "url(#paint9_linear_79_527)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9842,
    cy: 4.90416,
    r: 4.90416,
    fill: "url(#paint10_linear_79_527)"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.9842,
    cy: 4.90416,
    r: 4.90416,
    fill: "url(#paint11_linear_79_527)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_79_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M101.812 35.9884C101.812 37.3041 101.56 38.5384 101.058 39.6914C100.555 40.8446 99.8677 41.8572 98.9956 42.7294C98.1382 43.5868 97.1329 44.2667 95.9799 44.7695C94.8268 45.2721 93.5925 45.5233 92.2768 45.5233H76.3779V13.7256H92.2768C93.5925 13.7256 94.8268 13.9769 95.9799 14.4795C97.1329 14.9821 98.1382 15.6695 98.9956 16.5417C99.8677 17.3991 100.555 18.4043 101.058 19.5574C101.56 20.7104 101.812 21.9448 101.812 23.2605C101.812 23.8518 101.73 24.4579 101.568 25.0788C101.405 25.6996 101.176 26.2983 100.88 26.8749C100.585 27.4514 100.23 27.9762 99.816 28.4492C99.4021 28.9223 98.9438 29.314 98.4412 29.6245C98.9586 29.9053 99.4243 30.2897 99.8382 30.7775C100.252 31.2506 100.607 31.7753 100.903 32.3519C101.198 32.9284 101.42 33.5345 101.568 34.1701C101.73 34.791 101.812 35.3971 101.812 35.9884ZM82.7419 39.1593H92.2768C92.7203 39.1593 93.1342 39.078 93.5186 38.9153C93.9029 38.7529 94.2355 38.5312 94.5164 38.2501C94.812 37.9546 95.0412 37.6145 95.2038 37.2302C95.3664 36.8458 95.4477 36.4319 95.4477 35.9884C95.4477 35.5449 95.3664 35.131 95.2038 34.7467C95.0412 34.3623 94.812 34.0297 94.5164 33.7488C94.2355 33.4532 93.9029 33.224 93.5186 33.0614C93.1342 32.8988 92.7203 32.8175 92.2768 32.8175H82.7419V39.1593ZM82.7419 26.4535H92.2768C92.7203 26.4535 93.1342 26.3723 93.5186 26.2096C93.9029 26.047 94.2355 25.8253 94.5164 25.5444C94.812 25.2488 95.0412 24.9088 95.2038 24.5244C95.3664 24.1253 95.4477 23.704 95.4477 23.2605C95.4477 22.817 95.3664 22.4031 95.2038 22.0187C95.0412 21.6344 94.812 21.3017 94.5164 21.0209C94.2355 20.7252 93.9029 20.4961 93.5186 20.3335C93.1342 20.1709 92.7203 20.0896 92.2768 20.0896H82.7419V26.4535ZM107.694 23.3014C108.48 23.327 108.008 23.2937 109.194 23.3014C110.223 23.3014 110.151 23.3014 111.031 23.3014V34.5335C111.031 35.2298 111.167 35.8958 111.44 36.5316C111.712 37.1371 112.076 37.6669 112.53 38.1211C112.984 38.5752 113.514 38.9386 114.119 39.2109C114.755 39.4835 115.421 39.6198 116.117 39.6198C116.783 39.6198 117.419 39.4985 118.025 39.2564C118.63 39.0141 119.16 38.6813 119.614 38.2574C120.099 37.8334 120.477 37.3188 120.75 36.7133C121.022 36.1078 121.158 35.4568 121.158 34.7605V23.1804C121.158 23.1441 121.286 23.1804 121.988 23.1804C122.968 23.1804 123.276 23.2107 124.094 23.1804C124.911 23.1804 125.05 23.1804 126.115 23.1804C127.035 23.1804 127.153 23.1804 127.153 23.1804V34.5335C127.153 36.0472 126.865 37.4701 126.29 38.8023C125.715 40.1344 124.927 41.3 123.928 42.299C122.929 43.298 121.764 44.0852 120.432 44.6606C119.1 45.2357 117.661 45.5233 116.117 45.5233C114.664 45.5838 113.272 45.3418 111.939 44.7966C110.607 44.2215 109.427 43.4495 108.397 42.4808C107.398 41.4815 106.596 40.3312 105.99 39.0294C105.385 37.6972 105.082 36.3046 105.082 34.8513V23.3014C105.854 23.3014 105.118 23.3014 105.975 23.3014C107.088 23.3014 106.846 23.3014 107.694 23.3014ZM132.736 45.2086C131.918 45.2086 131.574 45.2086 130.775 45.2086C130.097 45.2086 129.825 45.2449 129.825 45.1481V34.261C129.856 32.8078 130.158 31.4454 130.734 30.1738C131.339 28.872 132.126 27.7518 133.095 26.8133C134.094 25.8445 135.245 25.0876 136.546 24.5427C137.878 23.9674 139.119 23.6404 140.603 23.5798C140.603 23.5798 140.711 24.1971 140.815 24.9354C140.936 25.7947 140.965 26.0748 141.107 26.8477C141.24 27.574 141.252 27.6708 141.462 28.7964L141.559 29.4137L140.815 29.4927C140.119 29.5468 139.468 29.6289 138.863 29.9014C138.257 30.1436 137.727 30.4917 137.273 30.9458C136.819 31.4 136.456 31.9449 136.183 32.5807C135.91 33.1862 135.774 33.8523 135.774 34.5789V42.8439C135.774 43.6231 135.818 44.6398 135.774 45.2086C135.121 45.2449 134.321 45.2086 132.736 45.2086ZM163.323 33.4384C163.323 32.6106 163.16 31.8123 162.835 31.0436C162.524 30.2601 162.096 29.5727 161.549 28.9814C161.002 28.3753 160.359 27.8949 159.62 27.5401C158.895 27.1705 158.119 26.9857 157.291 26.9857C156.464 26.9857 155.68 27.1262 154.941 27.407C154.217 27.6879 153.581 28.1018 153.034 28.6488C152.502 29.1958 152.08 29.8758 151.77 30.6888C151.46 31.4871 151.304 32.4036 151.304 33.4384C151.304 34.4288 151.46 35.3232 151.77 36.1215C152.08 36.905 152.502 37.5776 153.034 38.1393C153.581 38.7011 154.217 39.1371 154.941 39.4476C155.68 39.7432 156.464 39.8911 157.291 39.8911C158.119 39.8911 158.895 39.7137 159.62 39.3588C160.359 38.9894 161.002 38.5089 161.549 37.9176C162.096 37.3115 162.524 36.6241 162.835 35.8554C163.16 35.0719 163.323 34.2662 163.323 33.4384ZM169.421 42.5299C169.421 44.2002 169.103 45.7673 168.467 47.2306C167.832 48.6942 166.959 49.973 165.851 51.0669C164.757 52.1608 163.471 53.0255 161.992 53.6612C160.529 54.2968 158.962 54.6147 157.291 54.6147L154.253 54.5704V48.5167L157.247 48.5613C158.193 48.5613 158.999 48.4356 159.664 48.1841C160.329 47.9476 160.891 47.615 161.349 47.1863C161.807 46.7724 162.17 46.2921 162.436 45.7451C162.717 45.198 162.938 44.6216 163.101 44.0155C162.865 44.3999 162.524 44.7177 162.081 44.969C161.638 45.2055 161.142 45.3977 160.595 45.5456C160.063 45.708 159.501 45.8189 158.91 45.8782C158.334 45.9373 157.794 45.9668 157.291 45.9668C155.621 45.9668 154.046 45.6785 152.568 45.1021C151.105 44.5255 149.819 43.7051 148.71 42.6408C147.616 41.5616 146.751 40.246 146.116 38.6936C145.48 37.1415 145.162 35.3897 145.162 33.4384C145.162 31.6497 145.48 29.9866 146.116 28.4492C146.751 26.9118 147.616 25.5814 148.71 24.4579C149.819 23.3344 151.045 22.3879 152.508 21.7522C153.986 21.1166 154.336 21.0744 156.006 20.8081C156.841 20.7476 158.27 20.6599 159.141 20.7476C160.013 20.8354 160.315 20.8687 161.114 21.0744C161.913 21.2802 162.566 21.4382 163.323 21.8191C163.673 21.9955 164.045 22.2406 164.435 22.5203C165.389 23.2057 166.227 24.0391 166.972 24.9475C167.555 25.8984 167.946 26.9547 168.122 28.0563L168.467 30.2125L169.421 42.5299ZM197.005 33.4384C197.005 35.2123 196.688 36.868 196.052 38.4053C195.416 39.9282 194.551 41.2511 193.457 42.3745C192.363 43.4834 191.077 44.3628 189.599 45.0133C188.136 45.649 186.561 45.9668 184.876 45.9668C183.206 45.9668 181.631 45.649 180.153 45.0133C178.69 44.3628 177.403 43.4834 176.295 42.3745C175.201 41.2511 174.336 39.9282 173.7 38.4053C173.065 36.868 172.747 35.2123 172.747 33.4384C172.747 31.6349 173.065 29.9644 173.7 28.427C174.336 26.8896 175.201 25.5666 176.295 24.4579C177.403 23.3344 178.69 22.4548 180.153 21.8191C181.631 21.1835 183.206 20.8657 184.876 20.8657C186.561 20.8657 188.136 21.1687 189.599 21.7748C191.077 22.3661 192.363 23.2161 193.457 24.3248C194.551 25.4187 195.416 26.7418 196.052 28.294C196.688 29.8314 197.005 31.5462 197.005 33.4384ZM190.907 33.4384C190.907 32.4627 190.745 31.5832 190.42 30.7997C190.109 30.0014 189.68 29.3214 189.134 28.7597C188.586 28.1831 187.944 27.747 187.204 27.4514C186.48 27.1409 185.704 26.9857 184.876 26.9857C184.048 26.9857 183.265 27.1409 182.526 27.4514C181.801 27.747 181.166 28.1831 180.619 28.7597C180.087 29.3214 179.665 30.0014 179.355 30.7997C179.044 31.5832 178.889 32.4627 178.889 33.4384C178.889 34.3549 179.044 35.2049 179.355 35.9884C179.665 36.7719 180.087 37.4519 180.619 38.0284C181.166 38.605 181.801 39.0632 182.526 39.4033C183.265 39.7284 184.048 39.8911 184.876 39.8911C185.704 39.8911 186.48 39.7359 187.204 39.4254C187.944 39.115 188.586 38.6788 189.134 38.1172C189.68 37.5554 190.109 36.8754 190.42 36.0771C190.745 35.2789 190.907 34.3993 190.907 33.4384Z",
    fill: "url(#paint12_linear_79_527)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_79_527)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5655 54.8932V48.7953L55.936 48.8396C56.5273 48.8396 57.0965 48.7435 57.6434 48.5515C58.1904 48.3593 58.693 48.0931 59.1513 47.7532C59.6243 47.4131 60.0382 47.0067 60.393 46.5337C60.7478 46.0753 61.0361 45.5727 61.2578 45.0257C60.5926 45.3066 59.9126 45.5875 59.2178 45.8683C58.5378 46.1492 57.8504 46.2896 57.1556 46.2896C55.6921 46.2896 54.3173 46.031 53.0312 45.5136C51.7451 44.9962 50.6142 44.2644 49.6386 43.3183C48.6777 42.3574 47.9164 41.197 47.3546 39.837C46.8077 38.4622 46.5342 36.9248 46.5342 35.2247V22.0977H52.5655V35.2247C52.5655 36.0674 52.6838 36.8065 52.9203 37.4422C53.1716 38.063 53.5043 38.5878 53.9182 39.0165C54.3321 39.4304 54.8125 39.7409 55.3595 39.9478C55.9212 40.1548 56.5199 40.2583 57.1556 40.2583C57.7765 40.2583 58.3604 40.1178 58.9074 39.837C59.4691 39.5413 59.9569 39.157 60.3708 38.6839C60.7848 38.2109 61.11 37.6787 61.3465 37.0874C61.583 36.4813 61.7013 35.8604 61.7013 35.2247V22.0977H67.7992V42.8527C67.7844 44.5231 67.4592 46.0901 66.8235 47.5535C66.1879 49.017 65.3157 50.2959 64.207 51.3898C63.1131 52.4837 61.8343 53.3484 60.3708 53.984C58.9074 54.6197 57.3404 54.9375 55.6699 54.9375L52.5655 54.8932Z",
    fill: "url(#paint13_linear_79_527)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_527",
    x1: 31.0598,
    y1: 85.0055,
    x2: 68.4082,
    y2: 54.3877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544647,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_527",
    x1: 35.9635,
    y1: 21.2521,
    x2: 7.08833,
    y2: 25.7872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544647,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_527",
    x1: 10.1462,
    y1: 46.1781,
    x2: 11.2917,
    y2: 30.2755,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B057DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_527",
    x1: 8.13032,
    y1: 45.5694,
    x2: 20.1113,
    y2: 37.4554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D00B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8AFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_79_527",
    x1: 1.84074e-7,
    y1: 43.2551,
    x2: 16.3532,
    y2: 41.9126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.544647,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_79_527",
    x1: 27.7893,
    y1: 4.80826e-7,
    x2: 23.5195,
    y2: 6.83393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF67A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_79_527",
    x1: 4.08627,
    y1: 14.7128,
    x2: 8.71973,
    y2: 15.4746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B5003E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF66A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_79_527",
    x1: 5.33212,
    y1: 18.9842,
    x2: 6.30409,
    y2: 14.8063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E38CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_79_527",
    x1: 5.50994,
    y1: 19.5115,
    x2: 10.1543,
    y2: 16.3904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477264,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_79_527",
    x1: 27.7893,
    y1: 4.80826e-7,
    x2: 23.5195,
    y2: 6.83393,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9B3899"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF67A1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_79_527",
    x1: 25.8825,
    y1: 8.85912,
    x2: 27.3404,
    y2: 2.59233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5D1581"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CC8BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_79_527",
    x1: 26.1492,
    y1: 9.65011,
    x2: 33.1158,
    y2: 4.96834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#602EF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.477264,
    stopColor: "#7A53FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A490FE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_79_527",
    x1: 76.6152,
    y1: 32.3542,
    x2: 199.38,
    y2: 33.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A3CF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A08BFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_79_527",
    x1: 46.7506,
    y1: 29.3139,
    x2: 70.1493,
    y2: 29.3139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6535F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E6FFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_79_527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120.671,
    height: 40.9095,
    fill: "white",
    transform: "translate(76.3291 13.7148)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_79_527"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.2778,
    height: 32.8729,
    fill: "white",
    transform: "translate(46.5244 22.0752)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyburgoLogo);
export default __webpack_public_path__ + "static/media/myburgoLogo.8afac2415616db01d67508d9c564642f.svg";
export { ForwardRef as ReactComponent };